export const API_URLS = {
  runAutomateAssigning: '/sc-api/automate',
  addOpsUser: '/sc-api/ops/user',
  getCaseStatus: '/sc-api/case/#{caseId}/status',
  getVerificationRequest: '/sc-api/verification-request/#{verificationRequest}',
  validateCase: '/sc-api/case/#{caseId}/validate',
  assignOpsUser:
    '/sc-api/case/allocate?workflowId=#{caseId}&opsId=#{opsUserId}&userId=#{userId}&vrId=#{entityId}',
  getAllCases: '/sc-api/automate/getAllVrAutomationData',
  getAllOpsUser: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/ops/filter/users`,
  getAllClaims: `/sc-api/automate/assessment?vrId=#{verificationRequestId}`,
  // getSsoLoginUrl: `/sc-api/user/getSsoUrl?redirectionUrl=#{redirectUrl}`,
  // ssoLogin: `/sc-api/user/ssoLogin?code=#{code}&redirectionUrl=#{redirectUrl}`,
  getSsoLoginUrl: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/user/getSsoUrl?redirectionUrl=#{redirectUrl}`,
  ssoLogin: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/user/ssoLogin?code=#{code}&redirectionUrl=#{redirectUrl}`,
  ssoLogOutUrl: `/sc-api/user/ssoLogOut`,
  getUserProfile: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/user/id`,
  getAllAssessments: '/sc-api/automate/getAllTrainingApplicantData',
  getAssessmentDetails: '/sc-api/automate/getUserSpeceficTrainingData',
  trackProgress: `/sc-api/track-progress`,
  userSpecificProgress: `/sc-api/track-progress/get-user-specific-progress`,
  traineeSpecificProgress: `/sc-api/track-progress/trainee-specific-data`,
  myAssignments: '/sc-api/assignment',
  traineePendingAssessments: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/test`,
  traineeUpdateTest: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/test/#{testId}`,
  trainingTerminate: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/training/#{trainingId}/terminate`,
  traineePendingAssessmentExercisesResult: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/test-exercise-result`,
  traineeUpdateExercisesResult: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/test-exercise-result/#{testExerciseResultId}`,
  traineeCanStartExercise: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/test-exercise-result/#{testExerciseResultId}/can-start`,
  trainerTrackAssessment: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/assessment-v2/track-assessment`,
  getAllAssesments: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/assessment-v2?filter=#{filter}`,
  createAssesment: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/assessment-v2`,
  getAllExercises: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/exercise`,
  createExercise: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/exercise`,
  getAllScenarios: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/test-runner/get-all-scenarios`,
  trainingAssign: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/training`,
  trainingDowntimeConfig: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/training/downtime-config`,
  getExerciseAssertionResult: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/test-exercise-result/get-assertion-result/#{testExerciseResultId}`,
  getAllComponentBank: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/component-bank`,
  uploadComponentBankData: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/data-bank/populate-from-excel`,
  populateDataBank: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/data-bank/#{caseId}`,
  getTestComponentBankAttributes: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/component-bank/attribute-details/#{componentId}`,
  getTraineeTestDetails: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/test/#{testId}`,
  uploadComponentBankDataPollingStatus: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/data-bank/processing-status/#{processingId}`,
  getAllClients: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/test-runner/get-all-clients`,
  getAllClientContracts: `${process.env.NEXT_PUBLIC_SVAYAMCHALAK_URL}/test-runner/get-client-contracts-by-client-id/#{clientId}`
};

export const NO_TASKS_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/noTask.png`;

export const DOCUMENT_UPLOAD_URL = `${process.env.NEXT_PUBLIC_DOCUMENT_SERVICE_URL}/upload`;
